import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                     from '../../api/api.service';
import { ConfirmationCustomComponent }    from './confirmation.custom.component';
import { ConfirmationGenericComponent }   from './confirmation.generic.component';
import { ConfirmationHardComponent }      from './confirmation.hard.component';
import { ConfirmationNotifyComponent }    from './confirmation.notify.component';
import { ConfirmationQuestionComponent }  from './confirmation.question.component';
import { ConfirmationRememberComponent }  from './confirmation.remember.component';
import { ConfirmationSaveComponent }      from './confirmation.save.component';
import { ConfirmationSubscribeComponent } from './confirmation.subscribe.component';
import { ConfirmationTextComponent }      from './confirmation.text.component';
import { ConfirmOptionsModel }            from './typings/confirm.options';
import { SessionService }                 from '../../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  constructor (
    private apiService    : ApiService,
    private modalService  : NgbModal,
    private sessionService: SessionService
  ) {}

  custom ( options : ConfirmOptionsModel ) : Promise<string> {
    const modalRef = this.modalService.open(ConfirmationCustomComponent);

    modalRef.componentInstance.options = options;

    return modalRef.result;
  }

  generic ( message : string, type ?: string, options : ConfirmOptionsModel = {} ) : Promise<any> {
    options = Object.assign({}, {
      cancelText : 'GENERAL_SPACE.SWITCH.NO',
      confirmText: 'GENERAL_SPACE.SWITCH.YES',
      size       : 'md'
    }, options);

    const modalRef = this.modalService.open(ConfirmationGenericComponent, {
      size       : options.size,
      windowClass: `${ options.size }-modal`
    });

    modalRef.componentInstance.message = message;
    modalRef.componentInstance.options = options;
    modalRef.componentInstance.type    = type;

    return modalRef.result
  ;
  }
  hard ( message : string, type ?: string ) : Promise<void> {
    const modalRef = this.modalService.open(ConfirmationHardComponent);

    modalRef.componentInstance.message = message;
    modalRef.componentInstance.type    = type;

    return modalRef.result;
  }

  notify ( options : ConfirmOptionsModel ) : Promise<void> {
    const modalRef = this.modalService.open(ConfirmationNotifyComponent);

    modalRef.componentInstance.options = options;

    return modalRef.result;
  }

  question ( message : string, options : ConfirmOptionsModel = {} ) : Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationQuestionComponent);

    modalRef.componentInstance.icon    = options.icon;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.title   = options.title;

    return modalRef.result;
  }

  remember ( message : string, type : string, storageName = 'false' ) : Promise<void | boolean> {
    if ( this.sessionService.get(storageName) ) {
      return Promise.resolve();
    }
    else {
      const modalRef = this.modalService.open(ConfirmationRememberComponent);

      modalRef.componentInstance.message     = message;
      modalRef.componentInstance.storageName = storageName;
      modalRef.componentInstance.type        = type;

      return modalRef.result;
    }
  }

  save ( message : string, type ?: string ) : Promise<any> {
    const modalRef = this.modalService.open(ConfirmationSaveComponent);

    modalRef.componentInstance.message = message;
    modalRef.componentInstance.type    = type;

    return modalRef.result;
  }

  subscribe ( message : string, options : any ) : Promise<any> {
    return this.apiService.get(options.routes.quote)
    .then(quote => {
      const modalRef = this.modalService.open(ConfirmationSubscribeComponent);

      modalRef.componentInstance.message = message;
      modalRef.componentInstance.options = options;
      modalRef.componentInstance.quote   = quote;

      return modalRef.result;
    });
  }

  textConfirm ( message : string, phrase : string ) : ng.IPromise<void> {
    const modalRef = this.modalService.open(ConfirmationTextComponent);

    modalRef.componentInstance.message = message;
    modalRef.componentInstance.phrase  = phrase;

    return modalRef.result;
  }
}
